// extracted by mini-css-extract-plugin
export default {"button":"pagination_button__Lbng7","box":"pagination_box__7UjyC"};